// src/components/Product/MediaFileList.js (نسخه نهایی و اصلاح شده - واگذاری کامل)

import React from 'react';
import MediaItem from './MediaItem';
// 🛑 حذف ایمپورت‌های مربوط به مدیریت پلیر محلی:
// import useSecureMedia from '../../hooks/useSecureMedia'; 
// import MediaPlayerModal from '../common/Modal'; 
// import AudioVideoPlayer from '../players/AudioVideoPlayer';
// import PDFViewer from '../players/PDFViewer';
// import { usePlayerContext } from '../../context/PlayerContext'; 

// 🛑 تابع کمکی برای تبدیل ثانیه (فقط برای MediaItem استفاده می شود)
// import { convertToPersianNumbers } from '../../utils/PersianNumberUtils'; 


// 🛑 تنها props لازم: mediaFiles، productHasAccess، و تابع onPlay از والد
const MediaFileList = ({ mediaFiles, productHasAccess, onPlay }) => { 
  
  // 🛑 حذف تمام منطق useSecureMedia محلی و usePlayerContext
  
  // 🛑 FIX VITAL: تابع واسط تنها کارش فرستادن آیتم به ProductDetailPage است
  const handleMediaPlay = (mediaItem) => {
      // 💡 این تابع اطمینان می‌دهد که آیتم کلیک شده، به تابع onPlay والد برسد.
      if (onPlay) onPlay(mediaItem);
  }

  return (
    // 🌟 تغییر ۱: حذف کلاس‌های پس‌زمینه و اعمال padding ده پیکسلی (px-2.5) از هر طرف
    <section className="mb-0.5 mt-4 px-1 rtl w-full max-w-[460px] mx-auto "> 
      
      <h2 className="text-m font-extrabold text-gray-500 mb-1"> مـحتوای درسـگفتار</h2>
      
      {/* 🌟 تغییر ۲: اعمال خط جداکننده با ضخامت ۱ پیکسل (divide-gray-200 divide-y-[1px]) */}
      <div className="divide-y divide-gray-200 divide-y-[1px]">
        
        {(mediaFiles && Array.isArray(mediaFiles) && mediaFiles.length > 0) ? (
            mediaFiles.map((media) => (
                <MediaItem 
                    key={media.id} 
                    media={media} 
                    onPlay={handleMediaPlay} // 🛑 ارسال تابع جدید مدیریت (واگذاری)
                    productHasAccess={productHasAccess} 
                />
            ))
        ) : (
             <div className="flex justify-center p-4 text-gray-500">
                <p>این درس‌گفتار هنوز محتوای مدیا ندارد.</p>
            </div>
        )}
      </div>
      
      {/* 🛑 حذف MediaPlayerModal و منطق پلیر از این کامپوننت */}
    </section>
  );
};

export default MediaFileList;